import { render, staticRenderFns } from "./AddWork.vue?vue&type=template&id=2bb650fc&scoped=true"
import script from "./AddWork.vue?vue&type=script&lang=js"
export * from "./AddWork.vue?vue&type=script&lang=js"
import style0 from "./AddWork.vue?vue&type=style&index=0&id=2bb650fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb650fc",
  null
  
)

export default component.exports